import "./fleetViewError.css";

const FleetViewError = ({
  title = "Something went wrong",
  message = "We couldn’t load this information right now.",
  action = "Try Again",
  handleOnClick,
}) => {
  return (
    <div
      className="fleet-error-page"
      role="alert"
      aria-live="polite"
    >
      <div className="fd-error-card">
        <div
          className="fd-error-icon-wrapper"
          aria-hidden="true"
        >
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line
              x1="12"
              y1="16"
              x2="12.01"
              y2="16"
            />
          </svg>
        </div>

        <h3>{title}</h3>

        {message ? <p>{message}</p> : null}

        {typeof handleOnClick === "function" && (
          <button
            type="button"
            className="retry-btn"
            onClick={handleOnClick}
          >
            <i
              className="bi bi-arrow-clockwise"
              aria-hidden="true"
            />

            <span>{action}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default FleetViewError;